<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
        { label: 'MI PERFIL' }]">
      </app-breadcrumb>
    </div>

    @if (tipoUsuario != UserRole.Paciente) {
      <app-top-widgets/>
    }

    <app-profile-user [idGemp]="idGemp"/>
  </div>
</section>
